<template>
  <v-row>
    <v-col>
      <v-toolbar-title class="primary white--text px-4 py-3 title lighten-1"
        >Sign in to begin</v-toolbar-title
      >

      <v-btn
        data-cy-login
        v-if="!$auth.loading && !$auth.isAuthenticated"
        @click="login"
        medium
        style="display: block; height: 40px; text-transform: none"
        class="mt-5 primary title px-5"
        >Login</v-btn
      >
      <div v-if="$auth.isAuthenticated">
        <span class="text-muted font-weight-light px-2">{{
          $auth.user.name
        }}</span>
        <v-btn data-cy-logout small color="danger" @click="$auth.logout"
          >Logout</v-btn
        >
      </div>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: "Login",
  data() {
    return {
      rules: [(value) => !!value || "Required."],
    };
  },
  computed: {
    loading() {
      return this.$auth.loading;
    },
  },
  methods: {
    login: function () {
      this.$auth.loginWithRedirect();
    },
  },
  watch: {
    loading: function () {
      let vm = this;
      if (vm.loading == false && this.$auth.isAuthenticated) {
        this.$router.push("listReminders");
      }
    },
  },
};
</script>

<style scoped>
.login {
  display: flex;
  flex-direction: column;
  width: 30% !important;
  background-color: #fff;
}
.uppercase {
  text-transform: uppercase;
}
</style>